import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const AGENCIES_URL = "/agency/admin/manage-agencies/";

export const fetchAgencies = createAsyncThunk(
  "superuser/fetchAgencies",
  async (params, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      if (!token) return;

      const response = await axios.get(AGENCIES_URL, {
        params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response, 'response')

      // Based on typical backend responses, the data might be nested
      return response.data?.data
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch agencies"
      );
    }
  }
);

export const updateAgencyStatus = createAsyncThunk(
  "superuser/updateAgencyStatus",
  async ({ id, active }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      if (!token) return;

      const response = await axios.patch(`/agency/admin/manage-agencies/${id}/status/`, {
        active
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return { id, active, data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to update agency status"
      );
    }
  }
);

export const createAgency = createAsyncThunk(
  "superuser/createAgency",
  async (agencyData, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      if (!token) return thunkAPI.rejectWithValue("No token");

      const response = await axios.post(`/agency/admin/manage-agencies/`, agencyData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.response?.data || error.message || "Failed to create agency"
      );
    }
  }
);

export const fetchAgencyTypes = createAsyncThunk(
  "superuser/fetchAgencyTypes",
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      if (!token) return thunkAPI.rejectWithValue("No token");

      const response = await axios.get(`/agency/admin/create-agency-type/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message || "Failed to fetch agency types"
      );
    }
  }
);

export const editAgency = createAsyncThunk(
  "superuser/editAgency",
  async ({ id, data }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      if (!token) return thunkAPI.rejectWithValue("No token");

      const response = await axios.patch(`/agency/admin/manage-agencies/${id}/`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.response?.data || error.message || "Failed to update agency"
      );
    }
  }
);

const initialState = {
  agencies: [],
  agencies_loading: false,
  agencies_error: null,
  agencyTypes: [],
  agencyTypesLoading: false,
};

const superuserSlice = createSlice({
  name: "superuser",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgencies.pending, (state) => {
        state.agencies_loading = true;
        state.agencies_error = null;
      })
      .addCase(fetchAgencies.fulfilled, (state, action) => {
        state.agencies_loading = false;
        state.agencies = action.payload || [];
      })
      .addCase(fetchAgencies.rejected, (state, action) => {
        state.agencies_loading = false;
        state.agencies_error = action.payload || "Something went wrong";
        state.agencies = [];
      })
      .addCase(updateAgencyStatus.fulfilled, (state, action) => {
        if (state.agencies?.results) {
          const index = state.agencies.results.findIndex(a => a.id === action.payload.id);
          if (index !== -1) {
            state.agencies.results[index].active = action.payload.active;
          }
        }
      })
      .addCase(fetchAgencyTypes.pending, (state) => {
        state.agencyTypesLoading = true;
      })
      .addCase(fetchAgencyTypes.fulfilled, (state, action) => {
        state.agencyTypesLoading = false;
        // Depending on backend, could be action.payload.results, action.payload.data, or action.payload
        state.agencyTypes = action.payload?.data?.results || action.payload?.data || action.payload?.results || action.payload || [];
      })
      .addCase(fetchAgencyTypes.rejected, (state) => {
        state.agencyTypesLoading = false;
        state.agencyTypes = [];
      });
  },
});

export default superuserSlice.reducer;
